import React from "react";
import { View, StyleSheet, Text } from "react-native";
import MaterialIcons from "react-native-vector-icons/MaterialIcons";

const styles = StyleSheet.create({
  cell: {
    alignItems: "flex-start",
    justifyContent: "center",
    flex: 1,
  },
  imageCell: {
    alignItems: "flex-start",
    justifyContent: "center",
  },
});

export const originalTableData = [
  {
    aisle: 1,
    bay: 1,
    level: 1,
    slotId: 1,
    typeOfDamage: "Upright Columns",
    numberOfInstances: 1,
    severity: "Low",
    obsRecDate: "06/04/2025",
    tgtDtOfRepair: "06/07/2025",
    actDtOfRepair: "",
    status: "Active",
    comments: "Test",
    images: "image",
  },
  {
    aisle: 1,
    bay: 1,
    level: 1,
    slotId: 1,
    typeOfDamage: "Upright Columns",
    numberOfInstances: 1,
    severity: "Low",
    obsRecDate: "06/04/2025",
    tgtDtOfRepair: "06/07/2025",
    actDtOfRepair: "",
    status: "Active",
    comments: "Test",
    images: "image",
  },
];

export const tableColumns = [
  {
    columnKey: "aisle",
    header: "AISLE",
    renderCell: (item: any) => (
      <View style={styles.cell}>
        <Text>{item.aisle}</Text>
      </View>
    ),
  },
  {
    columnKey: "bay",
    header: "BAY",
    renderCell: (item: any) => (
      <View style={styles.cell}>
        <Text>{item.bay}</Text>
      </View>
    ),
  },
  {
    columnKey: "level",
    header: "LEVEL",
    renderCell: (item: any) => (
      <View style={styles.cell}>
        <Text>{item.level}</Text>
      </View>
    ),
  },
  {
    columnKey: "slotId",
    header: "SLOT ID",
    renderCell: (item: any) => (
      <View style={styles.cell}>
        <Text>{item.slotId}</Text>
      </View>
    ),
  },
  {
    columnKey: "typeOfDamage",
    header: "TYPE OF DAMAGE",
    renderCell: (item: any) => (
      <View style={styles.cell}>
        <Text>{item.typeOfDamage}</Text>
      </View>
    ),
  },
  {
    columnKey: "numberOfInstances",
    header: "NO OF INSTS.",
    renderCell: (item: any) => (
      <View style={styles.cell}>
        <Text>{item.numberOfInstances}</Text>
      </View>
    ),
  },
  {
    columnKey: "severity",
    header: "SEVERITY",
    renderCell: (item: any) => (
      <View style={styles.cell}>
        <Text>{item.severity}</Text>
      </View>
    ),
  },
  {
    columnKey: "obsRecDate",
    header: "Created Date",
    renderCell: (item: any) => (
      <View style={styles.cell}>
        <Text>{item.obsRecDate}</Text>
      </View>
    ),
  },
  {
    columnKey: "tgtDtOfRepair",
    header: "Target Date",
    renderCell: (item: any) => (
      <View style={styles.cell}>
        <Text>{item.tgtDtOfRepair}</Text>
      </View>
    ),
  },
  {
    columnKey: "actDtOfRepair",
    header: "Completion Date",
    renderCell: (item: any) => (
      <View style={styles.cell}>
        <Text>{item.actDtOfRepair || "-"}</Text>
      </View>
    ),
  },
  {
    columnKey: "status",
    header: "STATUS",
    renderCell: (item: any) => (
      <View style={styles.cell}>
        <Text>{item.status}</Text>
      </View>
    ),
  },
  {
    columnKey: "comments",
    header: "COMMENTS",
    renderCell: (item: any) => (
      <View style={styles.cell}>
        <Text>{item.comments}</Text>
      </View>
    ),
  },
  {
    columnKey: "images",
    header: "IMAGES",
    renderCell: (item: any) => (
      <View style={styles.imageCell}>
        {item.images && (
          <MaterialIcons name="image" size={24} color="#0066CC" />
        )}
      </View>
    ),
  },
];
